import * as Sentry from "@sentry/react"
import { maybeGetMetaVar } from "./getMetaVar"

const sentryJsDsn = maybeGetMetaVar("sentry-js-dsn")
const sentryEnv = maybeGetMetaVar("sentry-env")

if (sentryJsDsn) {
  Sentry.init({
    dsn: "https://9bf66a0355673cfe424d37c0fcd35bbe@o4505950240964608.ingest.us.sentry.io/4507742732615680",
    integrations: [
      Sentry.thirdPartyErrorFilterIntegration({
        // Specify the application keys that you specified in the Sentry bundler plugin
        filterKeys: ["meritfirst-frontend-js"],

        // Defines how to handle errors that contain third party stack frames.
        // Possible values are:
        // - 'drop-error-if-contains-third-party-frames'
        // - 'drop-error-if-exclusively-contains-third-party-frames'
        // - 'apply-tag-if-contains-third-party-frames'
        // - 'apply-tag-if-exclusively-contains-third-party-frames'
        behaviour: "apply-tag-if-contains-third-party-frames",
      }),
    ],
    environment: sentryEnv || "development",
  })
}
